export default "__VITE_ASSET__Bw8qX8$R__"